// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const contentApiId = '5071qg93jl'
const userApiId = 'bd4g7lfz82'
const backendApiId = '4mm2iqqdwl'
const stage = 'prod'

const awsmobile = {
  aws_project_region: 'ap-southeast-2',
  Auth: {
    region: 'ap-southeast-2',
    userPoolId: 'ap-southeast-2_xXQV6y7K7',
    userPoolWebClientId: '5veg1gqfkpbg5s9lkedar48ff6'
  },
  API: {
    endpoints: [
      {
        name: 'mctcnews',
        endpoint: `https://${contentApiId}.execute-api.ap-southeast-2.amazonaws.com/${stage}`
      },
      {
        name: 'mctcuser',
        endpoint: `https://${userApiId}.execute-api.ap-southeast-2.amazonaws.com/${stage}`
      },
      {
        name: 'backend-v2',
        endpoint: `https://${backendApiId}.execute-api.ap-southeast-2.amazonaws.com/${stage}`
      }
    ]
  }
}

export default awsmobile
